import {
  Input,
  Row,
  Col /*, Select, Typography*/,
  Dropdown,
  Menu,
  Checkbox,
  Button,
  Select,
} from 'antd';
import React, { useRef, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ButtonText, MenuItemText } from '../../../../shared/globalStyling/styledText';
import { DownOutlined } from '@ant-design/icons';
// const { Text } = Typography;
const { Option } = Select;

const DropDownStatusToggle = withRouter(({ location, history, orgLevel }) => {
  let statuses = [
    { text: 'Live', key: 'LIVE' },
    { text: 'Finished', key: 'FINISHED' },
    { text: 'In Attribution', key: 'ATTRIBUTION' },
    { text: 'Paused', key: 'PAUSED' },
  ];

  // Uncomment the following line if you want to include "Demo" status
  if (orgLevel !== 'STANDARD') statuses.push({ text: 'Demo', key: 'DEMO' });
  const params = new URLSearchParams(location.search);
  const selectedStatus = params.get('status');

  return (
    <Dropdown
      trigger={['click']}
      overlay={
        <Menu selectedKeys={[selectedStatus]}>
          {statuses.map((status, i) => {
            const isSelected = selectedStatus === status.key;
            return (
              <Menu.Item
                key={`${status.text}-${i}`}
                onClick={() => {
                  if (selectedStatus) {
                    params.delete('status');
                    sessionStorage.removeItem('advertiserMainStatus');
                  }
                  if (!isSelected) {
                    params.append('status', status.key);
                    sessionStorage.setItem('advertiserMainStatus', status.key);
                  }
                  history.push(`/advertiser/main/1?${params.toString()}`);
                }}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <Checkbox
                  checked={isSelected}
                  style={{
                    visibility: isSelected ? 'visible' : 'hidden',
                    marginRight: '8px',
                  }}
                />
                <MenuItemText text={status.text} />
              </Menu.Item>
            );
          })}
        </Menu>
      }
    >
      <Button
        style={{
          fontSize: '14px',
          width: '100%',
          height: '36px',
          marginRight: '10px',
        }}
        shape="round"
        type={!!selectedStatus ? 'primary' : 'default'}
        ghost={!!selectedStatus ? true : false}
      >
        <ButtonText text={'Status'} />
        <DownOutlined color="black" />
      </Button>
    </Dropdown>
  );
});

const FilterBar = ({ location, history, orgLevel, setData, data }) => {
  const searchRef = useRef(null);
  const params = new URLSearchParams(location.search);
  const [selectedDateRange, setSelectedDateRange] = useState('all');
  const [sessionDateRange] = useState(sessionStorage.getItem('advertiserMainDateRange'));
  const [searchQuery, setSearchQuery] = useState(params.get('search') || '');

  useEffect(() => {
    if (sessionDateRange && data) {
      setSelectedDateRange(sessionDateRange);
      applyDateFilter(sessionDateRange);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionDateRange, data]);

  useEffect(() => {
    if (!location.search) {
      const savedSearch = sessionStorage.getItem('advertiserMainSearch');
      const savedStatus = sessionStorage.getItem('advertiserMainStatus');

      let hasChanges = false;
      const newParams = new URLSearchParams();

      if (savedStatus && !params.get('status')) {
        newParams.append('status', savedStatus);
        hasChanges = true;
      }

      if (savedSearch && !params.get('search')) {
        newParams.append('search', savedSearch);
        setSearchQuery(savedSearch);
        hasChanges = true;
      }

      if (hasChanges) {
        history.replace(`/advertiser/main/1?${newParams.toString()}`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const applyDateFilter = (value) => {
    if (value === 'all') {
      setData(data);
    } else {
      const customData = data.map((advertiser) => {
        const customSummary = advertiser.customSummary;
        if (customSummary) {
          if (value === 'current') {
            const summary = customSummary.thisMonth;
            return {
              id: advertiser.id,
              name: advertiser.name,
              startDate: advertiser.startDate,
              endDate: advertiser.endDate,
              status: advertiser.status,
              impressions: summary.impressions || 0,
              transactions: summary.transactions || 0,
              revenue: summary.revenue || 0,
              totalImpressions: summary.totalImpressions || 0,
              signUps: summary.signUps || 0,
              sessions: summary.sessions || 0,
              signUpsAttrImpressions: summary.signUpsAttrImpressions || 0,
              sessionsAttrImpressions: summary.sessionsAttrImpressions || 0,
            };
          } else if (value === 'last') {
            const summary = customSummary.pastMonth;
            return {
              id: advertiser.id,
              name: advertiser.name,
              startDate: advertiser.startDate,
              endDate: advertiser.endDate,
              status: advertiser.status,
              impressions: summary.impressions || 0,
              transactions: summary.transactions || 0,
              revenue: summary.revenue || 0,
              totalImpressions: summary.totalImpressions || 0,
              signUps: summary.signUps || 0,
              sessions: summary.sessions || 0,
              signUpsAttrImpressions: summary.signUpsAttrImpressions || 0,
              sessionsAttrImpressions: summary.sessionsAttrImpressions || 0,
            };
          }
        }

        return {
          id: advertiser.id,
          name: advertiser.name,
          startDate: advertiser.startDate,
          endDate: advertiser.endDate,
          status: advertiser.status,
          impressions: 0,
          transactions: 0,
          revenue: 0,
          totalImpressions: 0,
          signUps: 0,
          sessions: 0,
        };
      });

      setData(customData);
    }
  };

  const handleDateRangeChange = (value) => {
    setSelectedDateRange(value);
    sessionStorage.setItem('advertiserMainDateRange', value);
    applyDateFilter(value);
  };

  return (
    <Row gutter={[16, 16]}>
      <Col>
        <DropDownStatusToggle orgLevel={orgLevel} />
      </Col>
      <Col>
        <Select value={selectedDateRange} style={{ width: 120 }} onChange={handleDateRangeChange}>
          <Option value="all">All Time</Option>
          <Option value="current">This Month</Option>
          <Option value="last">Last Month</Option>
        </Select>
      </Col>
      <Col>
        <Input.Search
          placeholder={'Search Advertiser Funnels'}
          ref={searchRef}
          style={{ width: '100%', height: '36px', fontSize: '14px' }}
          allowClear
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onSearch={(search) => {
            if (params.get('search')) {
              params.delete('search');
              sessionStorage.removeItem('advertiserMainSearch');
            }
            if (search) {
              params.append('search', search);
              sessionStorage.setItem('advertiserMainSearch', search);
              history.push(`/advertiser/main/1?${params.toString()}`);
            } else {
              setSearchQuery('');
              history.push(`/advertiser/main/1`);
            }
          }}
        />
      </Col>
    </Row>
  );
};

export default withRouter(FilterBar);
